// The questions for the "Which show should I see?" page.
// type "single" picks one answer, "age" picks the youngest child's age, "multi" picks any number.
export const STEPS = [
    { id: "party", type: "single", text: "Who is coming along?", options: [
      { value: "solo", label: "Just me" },
      { value: "date", label: "A date or partner" },
      { value: "friends", label: "A group of friends" },
      { value: "family", label: "A family with children" },
    ] },
    { id: "youngest", type: "age", when: (a) => a.party === "family", text: "How old is the youngest child?",
      note: "We only suggest shows that suit this age, using your site's guidance and ours.", options: [
      { value: 3, label: "Under 5" }, { value: 5, label: "5" }, { value: 6, label: "6" }, { value: 7, label: "7" },
      { value: 8, label: "8" }, { value: 9, label: "9" }, { value: 10, label: "10" }, { value: 11, label: "11" },
      { value: 12, label: "12" }, { value: 13, label: "13" }, { value: 14, label: "14" }, { value: 15, label: "15" },
      { value: 16, label: "16 or 17" },
    ] },
    { id: "frequency", type: "single", text: "How often do you go to the theatre?", options: [
      { value: "first", label: "This is my first time, or close to it" },
      { value: "sometimes", label: "Now and then" },
      { value: "often", label: "Regularly. I am a fan" },
    ] },
    { id: "feel", type: "single", text: "What do you most want from the night?", options: [
      { value: "laugh", label: "To laugh until it hurts" },
      { value: "moved", label: "To be moved" },
      { value: "thrill", label: "To be on the edge of my seat" },
      { value: "escape", label: "To escape into something spectacular" },
      { value: "think", label: "To be made to think" },
      { value: "love", label: "To fall in love, just a little" },
    ] },
    { id: "music", type: "single", text: "What about the music?", options: [
      { value: "songs", label: "Big songs, all the way through" },
      { value: "some", label: "A few good songs" },
      { value: "none", label: "No songs, just a play" },
      { value: "any", label: "I do not mind" },
    ] },
    { id: "story", type: "single", text: "What kind of story?", options: [
      { value: "magic", label: "Magic and fantasy" },
      { value: "history", label: "A true story or history" },
      { value: "love", label: "A love story" },
      { value: "dark", label: "Dark and twisty" },
      { value: "quirky", label: "Quirky and silly" },
    ] },
    { id: "scale", type: "single", text: "Big spectacle, or close-up?", options: [
      { value: "big", label: "Go big: sets, effects, scale" },
      { value: "close", label: "Close-up and intimate" },
      { value: "any", label: "Either is fine" },
    ] },
    { id: "familiar", type: "single", text: "Something famous, or something new?", options: [
      { value: "known", label: "A famous favourite" },
      { value: "new", label: "Something I have not heard of" },
      { value: "any", label: "Either" },
    ] },
    { id: "stars", type: "single", text: "Does a famous name on stage matter?", options: [
      { value: "yes", label: "Yes, I would love a star" },
      { value: "bonus", label: "It is a nice bonus" },
      { value: "no", label: "Not at all" },
    ] },
    { id: "length", type: "single", text: "How long a night?", options: [
      { value: "short", label: "Short and sweet, about two hours or less" },
      { value: "normal", label: "A normal evening, up to about three hours" },
      { value: "long", label: "I am happy to sit through a long one" },
    ] },
    { id: "budget", type: "single", text: "What is your budget per ticket?", options: [
      { value: 30, label: "Up to £30" }, { value: 50, label: "Up to £50" }, { value: 80, label: "Up to £80" },
      { value: 120, label: "Up to £120" }, { value: 0, label: "No limit" },
    ] },
    { id: "avoid", type: "multi", text: "Anything you would rather avoid?", note: "Pick any that apply, then continue.", options: [
      { value: "language", label: "Strong language and adult jokes" },
      { value: "heavy", label: "Upsetting themes" },
      { value: "loud", label: "Loud noises and flashing lights" },
      { value: "participation", label: "Audience participation" },
    ] },
  ];
  
  export const visibleSteps = (answers) => STEPS.filter((s) => !s.when || s.when(answers));